// extracted by mini-css-extract-plugin
module.exports = {"recommender":"zc-z"};